import * as React from "react";
import { useEffect } from "react";
import { Spin, message } from "antd";
import axios from "axios";
import { Templates } from "../../components/Templates/Templates";
import { getTemplates } from "../../store/slices/templates";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import {
  deleteTemplateByIdRoute,
  getTemplatesRoute,
  updateTemplateByIdRoute,
} from "../../lib/routes/templates";
import { Template } from "../../lib/interfaces/Template";
import { useAppDispatch, useAppSelector } from "../..";

export const TemplatesContainer = () => {
  const dispatch = useAppDispatch();
  const { templatesLoading } = useAppSelector((state) => state.templates);

  const createTemplate = (params: { body }) => {
    axios
      .post(getTemplatesRoute(), params.body)
      .then(() => {
        message.success("Шаблон создан");
        dispatch(getTemplates());
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  const updateTemplate = (params: { id: number; body: Template }) => {
    axios
      .patch(updateTemplateByIdRoute({ id: params.id }), params.body)
      .then(() => {
        message.success("Шаблон обновлен");
        dispatch(getTemplates());
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  const deleteTemplate = (params: { id: number }) => {
    axios
      .delete(deleteTemplateByIdRoute({ id: params.id }))
      .then(() => {
        message.success("Шаблон удален");
        dispatch(getTemplates());
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  useEffect(() => {
    !checkIsLoaded(templatesLoading) && dispatch(getTemplates());
  }, [templatesLoading]);

  return (
    <div className="container_height">
      <Spin spinning={checkIsLoading(templatesLoading)}>
        <Templates
          createTemplate={createTemplate}
          updateTemplate={updateTemplate}
          deleteTemplate={deleteTemplate}
        />
      </Spin>
    </div>
  );
};
